import React, { useState, useEffect, useRef, useMemo } from 'react'
import styled from 'styled-components';
import logo from '../../images/MegaPlazaBuilding.jpg';
import { delay } from '../../utils/delay';
import { addBank, editBank } from '../../redux/bankSlice';
import { useDispatch } from 'react-redux';
import { currentDateLocale } from '../../utils/currentDate';
import { useSelector } from 'react-redux';
import { mobile } from '../../responsive';

const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url(${logo})
      center;
      
  background-size: cover;
`

const Wrapper = styled.div`
    width: 60vw;
    background-color: white;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    ${mobile({
        width: '70vw',
    })};
`

const Title = styled.h1`
    text-decoration: underline;
    text-decoration-color: gray;
    text-underline-offset: 6px;
    margin: 5px;
    text-align: center;
`

const SubTitle = styled.h1`
    color: red;
    margin: 5px;
    font-size: 15px;
    
`

const Form = styled.div`
    display: flex;
    flex-direction: column;
`

const FormRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5px;

    ${mobile({
        flexWrap: 'wrap',
        justifyContent: 'center',
    })};
`

const FormColumn = styled.div`

`

const FormLabel = styled.h1`
    font-size: 20px;
    font-weight: 300;
    margin: 5px;
    padding: 10px;
    
     ${mobile({
         textAlign: 'center'
     })}
`

const FormInput = styled.input`
    padding: 10px;
    margin: 5px;
    font-size: 20px;
    width: 300px;
    border-radius: 5px;
    border: none;
   
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
     &:hover, &:focus {
         box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                 -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
   
     }
     
    ${mobile({
        width: '60vw'
    })};
`

const Button = styled.button`
   padding: 10px 20px;
    margin: 30px 20px;
    border-radius: 10px;
    color: white;
    background: rgba(0, 200, 200, 0.9);
    cursor: pointer;
    border: none;
    font-size: 20px;
    font-weight: bold;
    box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                inset 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                inset -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    
    &:hover{
        box-shadow: none;
    }
`

const FormMessageBox = styled.h1`
    height: 20px;
    font-size: 20px;
    margin: 0;
    visibility: ${props => props?.messageType ? 'visible' : 'hidden'};
    color: ${props => props?.messageType === 1 ? 'green' : 'red'};
`

const Bank = ({bankIdToEdit}) => {

    //console.log(bankIdToEdit);
    const initialState = {
        'bankId' : '',
        'bankName' : '',
        'bankDesc' : '',
        'bankCode' : '',
        'updatedDate' : '',
        'createdDate' : ''
    };
    const [bank, setBank] = useState(initialState);
    const [formMessage, setFormMessage] = useState({});
    const [edit, setEdit] = useState(false);
    const dispatch = useDispatch();
    const bankRedux = useSelector(state => state.bankRedux);
    const formRef = useRef();
    const banks = useMemo(() => [...bankRedux?.banks], [bankRedux?.banks]);
    

    const clearState = () => {
        setBank({...initialState});
        setEdit(false);
    };

    useEffect(() => {

        if(bankIdToEdit && bankIdToEdit.bankId && Number(bankIdToEdit.bankId) > 0){
            setEdit(true);
            const editDept = banks?.filter((item) => item.bankId === Number(bankIdToEdit.bankId));
            if(editDept && editDept[0]){
                setBank(editDept[0]);
            }
            
        }

        if(formRef.current){
            formRef.current.scrollIntoView({
                behavior: 'smooth',
            });
        }

        

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ bankIdToEdit]);

    const handleFormInput = (e) => {
        const {name, value} = e.target;
        setBank({...bank, [name]: value});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Create Bank Clicked');
        if (bank?.bankName && bank?.bankDesc) {
            console.log('No Errors');
            
            if(edit){
                await dispatch(
                    editBank({
                        ...bank, 
                        'updatedDate': currentDateLocale(),
                    })
                );
            }
            else{
                await dispatch(
                    addBank({
                        ...bank,
                        'bankId' : getNextAvailableId(), 
                        'createdDate': currentDateLocale(),
                    })
                );
            }
            
            await clearState();
            setFormMessage({'type' : 1, 'message' : 'Bank Saved Successfully'});
            //setBank({});

        } 
        else{
            console.log('Has Errors');
            setFormMessage({'type' : 2, 'message' : 'Some required fields are not filled'});
        }

        await delay(5000);

        setFormMessage({});

    }

    const getNextAvailableId = () => {
        return bankRedux && bankRedux.banks && bankRedux.banks.length > 0 
            ? bankRedux.banks[bankRedux.banks.length - 1].bankId + 1 : 1;
    };

    return (
        <Container ref={formRef}>
            <Wrapper>
                <Title>
                    {edit ? 'Edit Bank' : 'Create New Bank'}
                </Title>
                <SubTitle>
                    * == required
                </SubTitle>
                <FormMessageBox messageType={formMessage?.type}>
                    {formMessage?.message}
                </FormMessageBox>
                <Form>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Bank Name*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='bankName'
                                        placeholder= 'Enter Bank Name'
                                        value = {bank.bankName}
                                        onChange = {(e) => handleFormInput(e)} 

                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Bank Description*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='bankDesc'
                                        placeholder='Enter Bank Description'
                                        value={bank.bankDesc}
                                        onChange={(e) => handleFormInput(e)}
                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Bank Code
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='bankCode'
                                        placeholder='Enter Bank Code'
                                        value={bank.bankCode}
                                        onChange={(e) => handleFormInput(e)} />
                            
                        </FormColumn>
                    </FormRow>
                </Form>
                <Button onClick={(e) => handleSubmit(e)}>
                    {edit ? 'Edit Bank' : 'Create Bank'}
                </Button>
            </Wrapper>
        </Container>
    )
}

export default Bank
